var _circle, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitRetailersImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 261,
    viewBox: "0 0 331 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 102.5,
    r: 68.5,
    fill: "#F1C424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2038_21975)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 126.5,
    r: 110.5,
    fill: "#F1C424"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.033 145.23H84.2971L87.2462 139.224L136.247 139.135C137.904 139.135 139.324 137.951 139.62 136.314L146.406 98.3305C146.584 97.3343 146.317 96.3085 145.666 95.5293C145.345 95.1458 144.943 94.8369 144.49 94.624C144.037 94.4111 143.543 94.2993 143.043 94.2964L80.7068 94.0893L80.1742 91.584C79.8389 89.9861 78.3988 88.8223 76.7615 88.8223H61.5228C60.5993 88.8223 59.7137 89.1891 59.0608 89.842C58.4078 90.495 58.041 91.3806 58.041 92.304C58.041 93.2274 58.4078 94.113 59.0608 94.766C59.7137 95.4189 60.5993 95.7857 61.5228 95.7857H73.9406L76.2684 106.852L81.9989 134.598L74.6212 146.641C74.2381 147.158 74.0073 147.772 73.955 148.413C73.9027 149.055 74.031 149.698 74.3253 150.271C74.9171 151.444 76.1105 152.184 77.4322 152.184H83.6264C82.3059 153.938 81.5926 156.074 81.5945 158.27C81.5945 163.852 86.1316 168.389 91.7143 168.389C97.2969 168.389 101.834 163.852 101.834 158.27C101.834 156.07 101.104 153.93 99.8021 152.184H115.692C114.371 153.938 113.658 156.074 113.66 158.27C113.66 163.852 118.197 168.389 123.78 168.389C129.362 168.389 133.9 163.852 133.9 158.27C133.9 156.07 133.17 153.93 131.868 152.184H143.043C144.956 152.184 146.525 150.626 146.525 148.702C146.519 147.78 146.148 146.897 145.494 146.247C144.84 145.596 143.955 145.231 143.033 145.23V145.23ZM82.1567 100.954L138.95 101.142L133.387 132.29L88.775 132.369L82.1567 100.954ZM91.7143 161.386C89.998 161.386 88.5975 159.986 88.5975 158.27C88.5975 156.553 89.998 155.153 91.7143 155.153C93.4305 155.153 94.8311 156.553 94.8311 158.27C94.8311 159.096 94.5027 159.889 93.9182 160.474C93.3336 161.058 92.5409 161.386 91.7143 161.386V161.386ZM123.78 161.386C122.064 161.386 120.663 159.986 120.663 158.27C120.663 156.553 122.064 155.153 123.78 155.153C125.496 155.153 126.897 156.553 126.897 158.27C126.897 159.096 126.568 159.889 125.984 160.474C125.399 161.058 124.606 161.386 123.78 161.386V161.386Z",
    fill: "#8F7519"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2038_21975",
    x: 0,
    y: 0,
    width: 261,
    height: 261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2038_21975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2038_21975",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitRetailersImg);
export default __webpack_public_path__ + "static/media/benefit-retailers-img.475961a1b7039432202895418658def6.svg";
export { ForwardRef as ReactComponent };